// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grouped-packages-container[data-v-77a64c6a]{max-width:1200px!important}@media (min-width:320px) and (max-width:480px){.packages-container[data-v-77a64c6a]{padding-left:0;padding-right:0}}@media (min-width:481px) and (max-width:897px){.packages-container[data-v-77a64c6a]{padding-left:0;padding-right:0}}@media (min-width:898px) and (max-width:1023px){.packages-container[data-v-77a64c6a]{padding-left:0;padding-right:0}}", ""]);
// Exports
module.exports = exports;
